import { Pipe, PipeTransform } from '@angular/core';
import { ISalonAddressData } from '@app/shared/models/salon-address-data.model';

@Pipe({
  name: 'salonFormattedAddress'
})
export class SalonFormattedAddressPipe implements PipeTransform {

  transform(salonData: ISalonAddressData): string {
    let fullHouseNumber = salonData.salonHouseNumber;
    fullHouseNumber = salonData.salonHouseSubNumber ?
      `${fullHouseNumber} ${salonData.salonHouseSubNumber}` : fullHouseNumber;

    return `${salonData.salonStreet} ${fullHouseNumber}, ${salonData.salonCity}`;
  }

}
